import {Component, input} from '@angular/core'
import {AbstractControl, FormControl, FormControlStatus} from '@angular/forms'

@Component({
  selector: 'spb-step',
  template: '',
  styleUrls: []
})
export class StepComponent {
  readonly validControl =
    input<FormControl<boolean>>(new FormControl<boolean>(false, {nonNullable: true}))

  protected setValidator(control: AbstractControl): void {
    control.statusChanges.subscribe((validity: FormControlStatus) => {
      this.validControl().setValue(validity === 'VALID')
    })
  }
}
